var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coffee-index-home"},[(_vm.categories.length)?_c('coffee-category-list',{attrs:{"categories":_vm.categories,"plalist-data":_vm.playlistData,"brewlist-detail":_vm.brewlistDetails,"buy-now-props":_vm.buyNowProps,"load-non-categorized-coffees":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }